import React from "react";

import { StyledSVG } from "../StyledIcon";

export const SpeechIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.75 5C2.75 3.89543 3.64641 3 4.75098 3C8.22066 3 10.7793 3 14.249 3C15.3536 3 16.25 3.89543 16.25 5V11.2857C16.25 12.3903 15.3546 13.2857 14.25 13.2857H6.13059C5.80494 13.2857 5.49477 13.4246 5.27793 13.6676L4.49607 14.5436C3.88445 15.2289 2.75 14.7963 2.75 13.8778V5Z"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.75 5C2.75 3.89543 3.64641 3 4.75098 3C8.22066 3 10.7793 3 14.249 3C15.3536 3 16.25 3.89543 16.25 5V11.2857C16.25 12.3903 15.3546 13.2857 14.25 13.2857H6.13059C5.80494 13.2857 5.49477 13.4246 5.27793 13.6676L2.75 16.5V5Z"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </StyledSVG>
  );
};
